import React from 'react';
import _ from 'lodash';

import { useNetSuiteTaxItemSelectFieldQuery } from 'generated/graphql';



export interface INetSuiteTaxItem {
  id: string;
  displayName: string;
}

export interface IData {
  objects: INetSuiteTaxItem[];
}

export function useQuery() {
  const queryTuple = useNetSuiteTaxItemSelectFieldQuery();

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(queryTuple.data?.taxItems ?? [], (node): INetSuiteTaxItem => ({
        id: node.id,
        displayName: node.name
      }))
    };

    return {
      loading: queryTuple.loading,
      data,
      refetch: async () => {
        queryTuple.refetch({});
      }
    };
  }, [queryTuple]);

  return wrappedTuple;
}
